import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDocumentAttachmentFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.848 21.706c-2.01 0-4.02-.766-5.55-2.295A7.8 7.8 0 0 1 2 13.861c0-2.096.816-4.067 2.299-5.551l4.393-4.391a5.5 5.5 0 0 1 3.924-1.626c1.482 0 2.876.577 3.923 1.626a5.51 5.51 0 0 1 1.625 3.924 5.51 5.51 0 0 1-1.625 3.924l-4.285 4.285c-1.245 1.246-3.416 1.246-4.662 0a3.28 3.28 0 0 1-.965-2.331c0-.88.343-1.708.965-2.331l4.044-4.044A.999.999 0 1 1 13.05 8.76l-4.043 4.044c-.245.245-.38.571-.38.917s.135.672.38.917c.49.49 1.343.49 1.832 0l4.286-4.286a3.53 3.53 0 0 0 1.039-2.509c0-.949-.37-1.839-1.04-2.51-1.34-1.342-3.677-1.342-5.018 0L5.713 9.725A5.8 5.8 0 0 0 4 13.861c0 1.563.608 3.032 1.713 4.136a5.86 5.86 0 0 0 8.27 0l6.31-6.31a1 1 0 0 1 1.414 1.415l-6.31 6.309a7.83 7.83 0 0 1-5.55 2.295"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDocumentAttachmentFilled);
export default ForwardRef;
